import React from "react";
import { BrowserRouter, HashRouter, Switch } from "react-router-dom";
import { Anasayfacopy_Screen } from "../screens/anasayfacopy/anasayfacopy";
import { STDReportsUser_Screen } from "../screens/stdreportsuser/stdreportsuser";
import { TeslimTesellumWeb_Screen } from "../screens/teslimtesellumweb/teslimtesellumweb";
import { Layout2_Screen } from "../screens/layout2/layout2";
import { STDReportsUsercopy_Screen } from "../screens/stdreportsusercopy/stdreportsusercopy";
import { AddForeCast_Screen } from "../screens/addforecast/addforecast";
import { STDOrders_List_Screen } from "../screens/stdorders_list/stdorders_list";
import { DuzeltilecekKirilimEkrani_Screen } from "../screens/duzeltilecekkirilimekrani/duzeltilecekkirilimekrani";
import { MailGrubuYetkiliEkle_Screen } from "../screens/mailgrubuyetkiliekle/mailgrubuyetkiliekle";
import { BoxLogs_Screen } from "../screens/boxlogs/boxlogs";
import { STDNoScreen_Form_Screen } from "../screens/stdnoscreen_form/stdnoscreen_form";
import { TeslimTesellumFinal_Screen } from "../screens/teslimtesellumfinal/teslimtesellumfinal";
import { STDUsers_List_Screen } from "../screens/stdusers_list/stdusers_list";
import { UserGroup_Listcopy_Screen } from "../screens/usergroup_listcopy/usergroup_listcopy";
import { STDOrders_Form_Screen } from "../screens/stdorders_form/stdorders_form";
import { Eslestirme_Screen } from "../screens/eslestirme/eslestirme";
import { Station_List_Screen } from "../screens/station_list/station_list";
import { Orders_List_Screen } from "../screens/orders_list/orders_list";
import { STDUserGroup_List_Screen } from "../screens/stdusergroup_list/stdusergroup_list";
import { Signup_Screen } from "../screens/signup/signup";
import { Signin_Screen } from "../screens/signin/signin";
import { STDOrders_FormQR_Screen } from "../screens/stdorders_formqr/stdorders_formqr";
import { NavigateScreen_Screen } from "../screens/navigatescreen/navigatescreen";
import { STDReportsUserOld_Screen } from "../screens/stdreportsuserold/stdreportsuserold";
import { STDSapUser_Form_Screen } from "../screens/stdsapuser_form/stdsapuser_form";
import { STDCustomer_Form_Screen } from "../screens/stdcustomer_form/stdcustomer_form";
import { EslestirmeTeslimTesellum_Screen } from "../screens/eslestirmeteslimtesellum/eslestirmeteslimtesellum";
import { STDProducts_Form_Screen } from "../screens/stdproducts_form/stdproducts_form";
import { STDSapUser_View_Screen } from "../screens/stdsapuser_view/stdsapuser_view";
import { STDBoxes_Details_Screen } from "../screens/stdboxes_details/stdboxes_details";
import { User_Form_Screen } from "../screens/user_form/user_form";
import { ResetPassword_Screen } from "../screens/resetpassword/resetpassword";
import { ForgotPassword_Screen } from "../screens/forgotpassword/forgotpassword";
import { STDBoxes_Form_Manuel_Screen } from "../screens/stdboxes_form_manuel/stdboxes_form_manuel";
import { Screen_Group_Employee_Grid_Card_with_Search_Screen } from "../screens/screen_group_employee_grid_card_with_search/screen_group_employee_grid_card_with_search";
import { STDBoxes_List_Screen } from "../screens/stdboxes_list/stdboxes_list";
import { DefaLogoutScreen_Screen } from "../screens/defalogoutscreen/defalogoutscreen";
import { STDBoxes_Form_Screen } from "../screens/stdboxes_form/stdboxes_form";
import { CustomerProducts_Screen } from "../screens/customerproducts/customerproducts";
import { SQLQueryScreen_Screen } from "../screens/sqlqueryscreen/sqlqueryscreen";
import { AdminPanel_Screen } from "../screens/adminpanel/adminpanel";
import { STDBoxes_Listcopy_Screen } from "../screens/stdboxes_listcopy/stdboxes_listcopy";
import { STDMailGroups_Form_Screen } from "../screens/stdmailgroups_form/stdmailgroups_form";
import { STDUserGroups_Form_Screen } from "../screens/stdusergroups_form/stdusergroups_form";
import { Layout1_Screen } from "../screens/layout1/layout1";
import { Station_View_Screen } from "../screens/station_view/station_view";
import { STDProducts_View_Screen } from "../screens/stdproducts_view/stdproducts_view";
import { UserGroup_List_Screen } from "../screens/usergroup_list/usergroup_list";
import { Anasayfa_Screen } from "../screens/anasayfa/anasayfa";
import { STDProducts_Equivalence_Form_Screen } from "../screens/stdproducts_equivalence_form/stdproducts_equivalence_form";
import { EslestirmeOld_Screen } from "../screens/eslestirmeold/eslestirmeold";
import { Customer_List_Screen } from "../screens/customer_list/customer_list";
import { STDNoScreen_List_Screen } from "../screens/stdnoscreen_list/stdnoscreen_list";
import { STDCustomer_View_Screen } from "../screens/stdcustomer_view/stdcustomer_view";
import { LeftMenu_Screen } from "../screens/leftmenu/leftmenu";
import { STDNoScreen_View_Screen } from "../screens/stdnoscreen_view/stdnoscreen_view";
import { STDSapUser_List_Screen } from "../screens/stdsapuser_list/stdsapuser_list";
import { MailGroups_Screen } from "../screens/mailgroups/mailgroups";
import { NewLayout_Screen } from "../screens/newlayout/newlayout";
import { STDOrders_View_Screen } from "../screens/stdorders_view/stdorders_view";
import { CustomerByProductId_Screen } from "../screens/customerbyproductid/customerbyproductid";
import { VerificationCode_Screen } from "../screens/verificationcode/verificationcode";
import { Screen_Group_Grid_Card_with_Search_Screen } from "../screens/screen_group_grid_card_with_search/screen_group_grid_card_with_search";
import { STDStations_Form_Screen } from "../screens/stdstations_form/stdstations_form";
import { Product_List_Screen } from "../screens/product_list/product_list";



import LocalStorageService from "../auth/local-storage-service";
import { Redirect } from "../auth/redirect";
import { IAppMode, IAuthType } from "../bootstrapper";
import { NoMatch404 } from "../components/common/no-match-404";
import { Dashboard, ForgotPassword, Login, ResetPassword } from "../components/default_screens/index";
import { KuikaInfo } from "../components/default_screens/kuika-info";
import { MfeLogin } from "../components/mfe/mfe-login";
import { MsalLogin } from "../components/msal/msal-login";
import { MsalRedirect } from "../components/msal/msal-redirect";
import { NotificationRedirect } from "../components/notification/notification-redirect";
import { WFMailInteraction } from "../screens/wf-mail-interaction";
import { KMainFunctions } from "../shared/utilty/main-functions";
import { PrivateRoute } from "./private-route";
import { Route } from "./route";

const confJson = require("../shared/json/conf.json");

export interface IRouterState {}

export type IRouterType = "HashRouter" | "BrowserRouter";

export interface IRouterProps {
  authType: IAuthType;
  routerType?: IRouterType;
  external_access_token?: string;
  external_refresh_token?: string;
  external_user?: string;
  startingScreen?: string;
  appMode?: IAppMode;
  // Allow only screenInput_* props with specific typing
  [key: `screenInput_${string}`]: unknown;
}

declare let window: any;
export class Router extends React.Component<IRouterProps, IRouterState> {
  timerId: any = null;

  private hasNavigatedToStartingScreen: boolean = false;

  componentDidMount = () => {
    // SET LANGUAGE TO HTML BODY
    const lang = LocalStorageService.getUserLanguage();
    if (lang) {
      const fixedLangAttributeValue = lang.replace("_", "-");
      document.body.setAttribute("lang", fixedLangAttributeValue);
    }
    // Handle starting screen navigation for web component apps (only once)
    if (this.props.appMode === "WebComponent" && this.props.startingScreen && !this.hasNavigatedToStartingScreen) {
      this.hasNavigatedToStartingScreen = true;
      this.navigateToStartingScreen();
    }

    window.onfocus = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = true;
    };

    window.onblur = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = false;
    };

    if (!window.styler_speed) {
      window.styler_speed = 20;
    } else if (window.styler_speed < 500) {
      window.styler_speed += 100;
    }

    if (window?.kuika?.activeKuikaComponent !== undefined) {
      return;
    }
    const runTimeout = () => {
      this.timerId = setTimeout(() => {
        const allFormItems: NodeListOf<HTMLElement> = document.querySelectorAll(".kFormItem");
        if (allFormItems) {
          allFormItems.forEach((formItem) => {
            if (formItem.getAttribute("data-display-affected") === "true") {
              return;
            }
            const antFormItemControlInputContent: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content"
            );
            const antFormItemControlInput: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input"
            );
            const antFormItemControl: HTMLElement = formItem.querySelector(".ant-form-item-control");

            if (
              antFormItemControlInputContent &&
              antFormItemControlInputContent.children &&
              antFormItemControlInputContent.children.length > 0
            ) {
              const formChild: HTMLElement = antFormItemControlInputContent.children[0] as HTMLElement;
              let calculatedDisplay: string = formChild.style.display;
              if (
                calculatedDisplay &&
                antFormItemControl &&
                antFormItemControlInput &&
                antFormItemControlInputContent
              ) {
                if (calculatedDisplay === "inline-flex" || calculatedDisplay === "inline-block") {
                  calculatedDisplay = "";
                  formItem.style.width = formChild.style.width ?? "auto";
                  formItem.style.display = "inline-block";
                  formItem.setAttribute("data-display-affected", "true");
                }
              }
            }
          });
        }
        this.componentDidMount();
      }, window.styler_speed);
    };

    runTimeout();

    setTimeout(() => {
      clearTimeout(this.timerId);
    }, 10000);
  };

  private getScreenInputPropKeys = (): string[] => {
    return Object.keys(this.props || {}).filter((k) => k && k.startsWith("screenInput_"));
  };

  private buildScreenInputsFromProps = (): Record<string, unknown> => {
    const screenInputs: Record<string, unknown> = {};
    this.getScreenInputPropKeys().forEach((key) => {
      const inputName = key.substring("screenInput_".length);
      screenInputs[inputName] = this.props[key];
    });
    return screenInputs;
  };

  private navigateToStartingScreen = () => {
    try {
      const screenName = this.props.startingScreen as string;
      const baseHash = screenName.startsWith("#") ? screenName : `#${screenName}`;
      const inputs = this.buildScreenInputsFromProps();
      const params = new URLSearchParams();

      Object.keys(inputs).forEach((k) => {
        const v = inputs[k];
        if (v !== undefined && v !== null) {
          params.append(k, typeof v === "string" ? v : JSON.stringify(v));
        }
      });

      const qs = params.toString();
      const hash = `${baseHash}${qs ? `?${qs}` : ""}`;

      if (window.location.hash !== hash) {
        window.location.hash = hash;
      }
    } catch (e) {
      console.error("Error navigating to starting screen:", e);
    }
  };

  render() {
    const KuikaRouter = this.KuikaRouter();
    return (
      <>
        <KuikaRouter>
          <Switch key="Switch">
            <PrivateRoute exact path="/" component={NavigateScreen_Screen} />
                        <PrivateRoute exact path="/anasayfacopy" component={Anasayfacopy_Screen} />
            <PrivateRoute exact path="/stdreportsuser" component={STDReportsUser_Screen} />
            <PrivateRoute exact path="/teslimtesellumweb" component={TeslimTesellumWeb_Screen} />
            <PrivateRoute exact path="/stdreportsusercopy" component={STDReportsUsercopy_Screen} />
            <PrivateRoute exact path="/addforecast" component={AddForeCast_Screen} />
            <PrivateRoute exact path="/stdorders_list" component={STDOrders_List_Screen} />
            <PrivateRoute exact path="/duzeltilecekkirilimekrani" component={DuzeltilecekKirilimEkrani_Screen} />
            <PrivateRoute exact path="/mailgrubuyetkiliekle" component={MailGrubuYetkiliEkle_Screen} />
            <PrivateRoute exact path="/boxlogs" component={BoxLogs_Screen} />
            <PrivateRoute exact path="/stdnoscreen_form" component={STDNoScreen_Form_Screen} />
            <PrivateRoute exact path="/teslimtesellumfinal" component={TeslimTesellumFinal_Screen} />
            <PrivateRoute exact path="/stdusers_list" component={STDUsers_List_Screen} />
            <PrivateRoute exact path="/usergroup_listcopy" component={UserGroup_Listcopy_Screen} />
            <PrivateRoute exact path="/stdorders_form" component={STDOrders_Form_Screen} />
            <PrivateRoute exact path="/eslestirme" component={Eslestirme_Screen} />
            <PrivateRoute exact path="/station_list" component={Station_List_Screen} />
            <PrivateRoute exact path="/orders_list" component={Orders_List_Screen} />
            <PrivateRoute exact path="/stdusergroup_list" component={STDUserGroup_List_Screen} />
            <Route exact path="/signup" component={Signup_Screen} />
            <Route exact path="/signin" component={this.LoginComponent()} />
            <PrivateRoute exact path="/stdorders_formqr" component={STDOrders_FormQR_Screen} />
            <PrivateRoute exact path="/navigatescreen" component={NavigateScreen_Screen} />
            <PrivateRoute exact path="/stdreportsuserold" component={STDReportsUserOld_Screen} />
            <PrivateRoute exact path="/stdsapuser_form" component={STDSapUser_Form_Screen} />
            <PrivateRoute exact path="/stdcustomer_form" component={STDCustomer_Form_Screen} />
            <PrivateRoute exact path="/eslestirmeteslimtesellum" component={EslestirmeTeslimTesellum_Screen} />
            <PrivateRoute exact path="/stdproducts_form" component={STDProducts_Form_Screen} />
            <PrivateRoute exact path="/stdsapuser_view" component={STDSapUser_View_Screen} />
            <PrivateRoute exact path="/stdboxes_details" component={STDBoxes_Details_Screen} />
            <PrivateRoute exact path="/user_form" component={User_Form_Screen} />
            <Route exact path="/resetpassword" component={ResetPassword_Screen} />
            <Route exact path="/forgotpassword" component={ForgotPassword_Screen} />
            <PrivateRoute exact path="/stdboxes_form_manuel" component={STDBoxes_Form_Manuel_Screen} />
            <PrivateRoute exact path="/screen_group_employee_grid_card_with_search" component={Screen_Group_Employee_Grid_Card_with_Search_Screen} />
            <PrivateRoute exact path="/stdboxes_list" component={STDBoxes_List_Screen} />
            <PrivateRoute exact path="/defalogoutscreen" component={DefaLogoutScreen_Screen} />
            <PrivateRoute exact path="/stdboxes_form" component={STDBoxes_Form_Screen} />
            <PrivateRoute exact path="/customerproducts" component={CustomerProducts_Screen} />
            <PrivateRoute exact path="/sqlqueryscreen" component={SQLQueryScreen_Screen} />
            <PrivateRoute exact path="/adminpanel" component={AdminPanel_Screen} />
            <PrivateRoute exact path="/stdboxes_listcopy" component={STDBoxes_Listcopy_Screen} />
            <PrivateRoute exact path="/stdmailgroups_form" component={STDMailGroups_Form_Screen} />
            <PrivateRoute exact path="/stdusergroups_form" component={STDUserGroups_Form_Screen} />
            <PrivateRoute exact path="/station_view" component={Station_View_Screen} />
            <PrivateRoute exact path="/stdproducts_view" component={STDProducts_View_Screen} />
            <PrivateRoute exact path="/usergroup_list" component={UserGroup_List_Screen} />
            <PrivateRoute exact path="/anasayfa" component={Anasayfa_Screen} />
            <PrivateRoute exact path="/stdproducts_equivalence_form" component={STDProducts_Equivalence_Form_Screen} />
            <PrivateRoute exact path="/eslestirmeold" component={EslestirmeOld_Screen} />
            <PrivateRoute exact path="/customer_list" component={Customer_List_Screen} />
            <PrivateRoute exact path="/stdnoscreen_list" component={STDNoScreen_List_Screen} />
            <PrivateRoute exact path="/stdcustomer_view" component={STDCustomer_View_Screen} />
            <PrivateRoute exact path="/leftmenu" component={LeftMenu_Screen} />
            <PrivateRoute exact path="/stdnoscreen_view" component={STDNoScreen_View_Screen} />
            <PrivateRoute exact path="/stdsapuser_list" component={STDSapUser_List_Screen} />
            <PrivateRoute exact path="/mailgroups" component={MailGroups_Screen} />
            <PrivateRoute exact path="/stdorders_view" component={STDOrders_View_Screen} />
            <PrivateRoute exact path="/customerbyproductid" component={CustomerByProductId_Screen} />
            <Route exact path="/verificationcode" component={VerificationCode_Screen} />
            <PrivateRoute exact path="/screen_group_grid_card_with_search" component={Screen_Group_Grid_Card_with_Search_Screen} />
            <PrivateRoute exact path="/stdstations_form" component={STDStations_Form_Screen} />
            <PrivateRoute exact path="/product_list" component={Product_List_Screen} />

            <Route path="/redirect" component={Redirect} />
            <Route path={"/login"} component={this.LoginComponent()} />
            
            
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <Route exact path="/kuikainfo" component={KuikaInfo} />
            <Route exact path="/msalredirect" component={MsalRedirect} />
            <Route exact path="/wfmailinteraction" component={WFMailInteraction} />
            <Route exact path="/notificationredirect" component={NotificationRedirect} />
            <Route path="*" component={NoMatch404} />
          </Switch>
        </KuikaRouter>
      </>
    );
  }

  KuikaRouter = () => {
    // Web component case
    let isWebComponentApp: any;
    isWebComponentApp = this.props.appMode === "WebComponent";
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app.appName === confJson.applicationName && app.workspace === confJson.domainName) {
          isWebComponentApp = true;
        }
      });
    }
    if (window.kuika === undefined) {
      window.kuika = {};
    }
    window.kuika.isWebComponentApp = isWebComponentApp;

    if (isWebComponentApp === true || this.props.routerType === "HashRouter") {
      return (props: any) => {
        return <HashRouter key="HashRouter">{props.children}</HashRouter>;
      };
    }
    return (props: any) => {
      if (KMainFunctions.virtualDirectoryURL === "auto" || window?.location?.protocol === "file:") {
        return <BrowserRouter key="BrowserRouter">{props.children}</BrowserRouter>;
      }
      return (
        <BrowserRouter basename={KMainFunctions.virtualDirectoryURL} key="BrowserRouter">
          {props.children}
        </BrowserRouter>
      );
    };
  };

  LoginComponent = () => {
    if (this.props.authType === "MSAL") {
      return MsalLogin;
    }

    const { external_access_token } = this.props;
    const { external_refresh_token } = this.props;
    const { external_user } = this.props;
    if (
      external_access_token !== null &&
      external_access_token !== undefined &&
      external_access_token !== "" &&
      external_refresh_token !== null &&
      external_refresh_token !== undefined &&
      external_refresh_token !== ""
    ) {
      return (props: any) => {
        return (
          <MfeLogin
            external_user={external_user}
            external_access_token={external_access_token}
            external_refresh_token={external_refresh_token}
          ></MfeLogin>
        );
      };
    }

    if (this.props.authType === "Kuika") {
      return Signin_Screen;
    }
    return <></>;
  };
}
